import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import './utils/rem.js';
import store from './store'
import global from "@/utils/Global"
import $ from 'jquery'
import Tracker from './tracker/tracker'

Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.prototype.$global = global

const tracker = new Tracker({
  appid: 'ar4143856560', // 应用标识，用来区分埋点数据中的应用
  uuid: '', // 设备标识，自动生成并存在浏览器中,
  extra: {}, // 用户自定义上传字段对象
  enableHeatMapTracker: false, // 是否开启热力图自动上报
  enableLoadTracker: false, // 是否开启页面加载自动上报，适合多页面应用的pv上报
  enableHistoryTracker: true, // 是否开启页面history变化自动上报，适合单页面应用的history路由
  enableHashTracker: true, // 是否开启页面hash变化自动上报，适合单页面应用的hash路由
  // requestUrl: 'http://localhost:8902/website/v1/api/tracker' // 埋点请求后端接口
  requestUrl: '/website/v1/api/tracker' // 埋点请求后端接口
})
Vue.prototype.tracker = tracker

Vue.prototype.toUrl = url => {
  if (store.getters.openEdit) {
    return false
  }
  window.open(url)
}

Vue.prototype.scrollToView = (clsNm) => {
  const obj = document.getElementsByClassName(clsNm)
  if(obj.length > 0) {
    setTimeout(() => {
      obj[0].scrollIntoView({ block: 'start', behavior: 'smooth' })
    }, 70)
  }
}

Vue.prototype.toHash = hash => {
  router.push(hash)
}
Vue.prototype.resizeFunc = (func, timeout) => {
  if (timeout) {
    setTimeout(() => {
      func()
    }, timeout)
  } else {
    func()
  }
}

window.tabChange = (clkObj, hidCls, shwCls, activeCls) =>{
  $(clkObj).siblings().removeClass(activeCls)
  $(clkObj).addClass(activeCls)
  $(hidCls).hide()
  $(shwCls).show()
}
Vue.use(ElementUI)

router.beforeEach((to, from, next) => {
  store.commit('SET_SHOW_FOOTER', false)
  if (!store.getters.loaded) {
    Promise.all([store.dispatch('getUserInfo'), store.dispatch('getCommonInfo'), store.dispatch('getDecorateInfo')]).then(() => {
      window.encrypt.setPublicKey(store.getters.commonInfo.pubKey)
      store.commit('SET_LOADED', true)
      if (store.getters.commonInfo.companyInfo.gray === 'Y') {
        document.getElementsByTagName('html')[0].className += 'jy-gray'
      }
      next()
    })
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  mounted() {
    window.addEventListener('resize', this.globalResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.globalResize);
  },
  methods: {
    globalResize() {
      setTimeout(() => {
        this.$emit('globalResize')
      }, 200)
    }
  },
  render: h => h(App),
}).$mount('#app')

